import get from 'lodash/get';
import set from 'lodash/set';

let rateLimits = {};

export default function limit(key, call, delay = 250) {
    if(!key) { throw new Error('Cant limit call rate with falsy key.') }

    let prev  = get(rateLimits, key);

    if(prev) { clearTimeout(prev); }

    let timeoutRef = setTimeout(() => {
        call();
    }, delay);

    set(rateLimits, key, timeoutRef);

    return timeoutRef;
}